// Module
var code = "<div class=\"text-empty-container\">\n    <div class=\"text-empty-container-elements {cls}\">\n        <div class=\"text-empty-image\"></div>\n        <p class=\"text-empty-body\">{[L(values.promptId, values.prompt)]}</p>\n    </div>\n</div>\n";
// Exports
module.exports = code;